angular.module('access.Nodes')
    .directive('accGetEsignatureLink', [
        '$translate',
        'nodeModalAction',
        function ($translate, nodeModalAction) {
            return {
                scope: {
                    esignature: '<accGetEsignatureLink'
                },
                link: function ($scope, elem) {
                    elem.on('click', function () {
                        $scope.node = $scope.esignature.mainItem;
                        $scope.node.esignature_uuid = $scope.esignature.uuid;

                        nodeModalAction(
                            $scope,
                            {
                                modalController: 'NodeGetLinkController',
                                modalType: 'confirm',
                                modalAction: 'get_link',
                                modalBodyTemplate: 'nodes/get_link',
                                modalActionButton: $translate.instant('Get Link'),
                                modalCancelButton: $translate.instant('Cancel'),
                                modalTitle: $scope.node.name,
                                modalSubTitle: $translate.instant('Revision') + ' ' + $scope.esignature.node_revision,
                                modalNotifications: true,
                                reloadCurrent: true
                            }
                        ).finally(function () {
                            $scope.$emit('reload.document', $scope.esignature.mainItem);
                        });
                    });
                }
            }
        }]);
